import { z } from 'zod';

export type TLocation = z.infer<typeof locationSchema>;

export const locationSchema = z
  .object({
    latitude: z.string(),
    longitude: z.string(),
  })
  .nullable();
